import Resources from '../../../../helpers/resources';

export const IS_SCHOOL_ADMIN = 'IS_SCHOOL_ADMIN';

function getIsSchoolAdmin() {
    return (dispatch) =>
        Resources.isAdmin
            .get()
            .send()
            .then((payload) =>
                dispatch({
                    type: IS_SCHOOL_ADMIN,
                    payload: payload.data
                })
            );
}

export default {
    getIsSchoolAdmin
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/is-admin/is-admin-actions.js